"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _rcCollapse = _interopRequireDefault(require("rc-collapse"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCollapse = require("./StyledCollapse");
var _Icon = _interopRequireDefault(require("../Icon"));
var _CollapseContext = require("./CollapseContext");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CollapsePanel = function CollapsePanel(props) {
  var parentProps = (0, _CollapseContext.useCollapseForm)();
  var prefixCls = props.prefixCls,
    className = props.className,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    _props$ellipsisContro = props.ellipsisControl,
    ellipsisControl = _props$ellipsisContro === void 0 ? false : _props$ellipsisContro,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? 'default' : _props$borderColor,
    forceRender = props.forceRender;
  var collapsePanelClassName = (0, _classnames.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-no-arrow"), !!prefixCls && !showArrow), "".concat(prefixCls, "-collapse-border-color-").concat(borderColor), borderColor));
  var preparedHeader = parentProps.ellipsisControl || ellipsisControl ? /*#__PURE__*/_react.default.createElement(_StyledCollapse.StyledHeaderContainer, null, props.header) : props.header;
  var panelProps = _objectSpread(_objectSpread({}, props), {}, {
    header: preparedHeader
  });
  if (parentProps.iconPosition === 'left' || props.iconPosition === 'left') {
    panelProps.header = null;
    panelProps.extra = /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-extra-container")
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "24",
      name: "angle-down"
    }), preparedHeader);
  }
  return /*#__PURE__*/_react.default.createElement(_rcCollapse.default.Panel, (0, _extends2.default)({}, panelProps, {
    className: collapsePanelClassName,
    forceRender: forceRender
  }));
};
var Collapse = function Collapse(props) {
  var prefixCls = props.prefixCls,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    bordered = props.bordered;
  var iconPosition = 'right'; // Bu feature dışarıya açılınca props üzerinden okunacak (props.iconPosition).
  var collapseClassName = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-borderless"), !!prefixCls && !bordered), className);
  var expandIcon = function expandIcon(_ref) {
    var isActive = _ref.isActive;
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "24",
      name: "angle-down",
      className: "collapse-angle-down"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_CollapseContext.CollapseProvider, (0, _extends2.default)({}, props, {
      iconPosition: iconPosition
    }), /*#__PURE__*/_react.default.createElement(_StyledCollapse.StyledCollapseContainer, {
      theme: theme,
      bordered: bordered,
      prefixCls: prefixCls
    }, function (styledPrefix) {
      return /*#__PURE__*/_react.default.createElement(_rcCollapse.default, (0, _extends2.default)({}, props, {
        bordered: bordered,
        prefixCls: styledPrefix,
        className: collapseClassName,
        expandIcon: iconPosition === 'right' ? expandIcon : null
      }));
    }));
  });
};
Collapse.Panel = CollapsePanel;
Collapse.propTypes = {
  prefixCls: _propTypes.default.string,
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  bordered: _propTypes.default.bool,
  showArrow: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  accordion: _propTypes.default.bool,
  activeKey: _propTypes.default.array,
  defaultActiveKey: _propTypes.default.array,
  ellipsisControl: _propTypes.default.bool,
  borderColor: _propTypes.default.oneOf(['primary', 'success', 'danger', 'default']),
  // iconPosition: PropTypes.oneOf(['left', 'right']),
  forceRender: _propTypes.default.bool
};
Collapse.defaultProps = {
  bordered: true,
  showArrow: true,
  accordion: false,
  activeKey: [],
  defaultActiveKey: [],
  forceRender: false
  // iconPosition: 'left',
};
var _default = exports.default = Collapse;